import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { FC, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import moment from 'moment-timezone';
import { IInputTimePicker } from './type';

const InputTimePicker: FC<IInputTimePicker> = ({
  name,
  isRequired = false,
  onChange,
  defaultValue,
  minTime,
  maxTime,
  onError,
  placeholder,
  sx,
  size = 'small',
}) => {
  const [open, setOpen] = useState(false);
  const { control } = useFormContext();

  const {
    field: { ref, ...pickerProps },
    formState: { errors },
  } = useController({
    control,
    name,
    rules: {
      required: isRequired,
    },
    defaultValue: defaultValue || '',
  });

  const handleChange = (date: moment.Moment | null) => {
    pickerProps.onChange(date);
    onChange(date);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <TimePicker
        {...(minTime && { minTime })}
        {...(maxTime && { maxTime })}
        value={pickerProps.value}
        onError={onError}
        ampm
        inputRef={ref}
        onChange={handleChange}
        open={open}
        sx={sx}
        onClose={() => setOpen(false)}
        desktopModeMediaQuery="@media (min-width: 300px)"
        slotProps={{
          textField: {
            onClick: () => setOpen(true),
            fullWidth: true,
            size,
            placeholder,
            error: !!errors[name],
          },
        }}
      />
    </LocalizationProvider>
  );
};

export { InputTimePicker };
